import React, { useEffect, useState } from "react";
import { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import { NavLink, useNavigate } from "react-router-dom";
import FundesciBlackLogo from "../../assets/img/common/fundesci-black-logo.svg";

import useAuth from "../../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";

import { ReactComponent as DisconnectIcon } from "../../assets/img/navbar/disconnect-icon.svg";
import { ReactComponent as ProfileIcon } from "../../assets/img/navbar/profile-icon.svg";
import { FaUserCircle, FaUserEdit, FaWallet } from "react-icons/fa";
import { AiTwotoneHome } from "react-icons/ai";
import { BsGridFill } from "react-icons/bs";
import { MdExplore } from "react-icons/md";
import { IoDocumentText, IoNotificationsSharp } from "react-icons/io5";
import { HiUserGroup } from "react-icons/hi";

import { useDisconnect, useAccount } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import useHandleCreateProject from "../../hooks/useHandleCreateProject";
import { accessToken, role } from "../../utils/localData";
import {
  selectGeneral,
  setRegisterModalType,
  setShowRegisterModal,
  setShowAuthModal,
} from "../../redux/slices/generalSlice";
import { UN_REGISTERED } from "../../Constants";
import NewNotifIcon from "../common/NewNotifIcon";
import { MdClose } from "react-icons/md";
import ExternalLink from "./ExternalLink";
const HamburgerMenu = ({ show, setShow }) => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector(selectGeneral);
  const { isConnected } = useAccount();
  const { openConnectModal } = useConnectModal();
  
  const handleClose = () => {
    setShow(false);
  };
  const modalRef = useRef(null);
  useOutsideClick(modalRef, handleClose, null, show);

  const { login } = useAuth();

  const { disconnect } = useDisconnect();
  const handleDisConnect = () => {
    handleClose();
    disconnect();
  };
  
  const handleConnectWallet = () => {
    handleClose();
    if (openConnectModal) {
      openConnectModal();
    }
  };
  
  const handleShowAuthModal = () => {
    handleClose();
    dispatch(setShowAuthModal({ show: true }));
  };

  const { handleCreateProject } = useHandleCreateProject();
  const CreateProject = () => {
    handleCreateProject();
    handleClose();
  };
  const handleCheckProfile = () => {
    // If no token, show the proper auth flow (email/Google signup)
    if (!accessToken()) {
      dispatch(setShowAuthModal({ show: true }));
    } else {
      // User has token but incomplete profile - show register modal
      dispatch(setRegisterModalType("withoutSignupBtn"));
      dispatch(setShowRegisterModal(true));
      login({ connectWallet: false });
    }
    handleClose();
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <div
      className={`w-full h-screen flex mlg:hidden justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0 z-50 roboto-font transition-all duration-300 ease-in ${
        show ? "translate-x-0 " : "translate-x-full overflow-hidden "
      }`}
    >
      <div
        ref={modalRef}
        className="w-full h-full flex flex-col items-center pb-10 bg-[#F2F2F3] "
      >
        <div className="w-full flex justify-between py-3 mb-5 pl-4 pr-8">
          <img
            src={FundesciBlackLogo}
            alt="FundesciLogo"
            className={`mt-2 h-14`}
          />
          <button onClick={handleClose} className="-mb-1">
            {/* <img src={CloseIcon} alt="CloseIcon" className="h-5" /> */}
            <MdClose className="" size={24} />
          </button>
        </div>

        {/* -------- menu items -------- */}

        <div className="w-full min-h-fit flex flex-col pr-8">
          <NavLink
            onClick={handleClose}
            to={"/"}
            className={({ isActive }) =>
              `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                isActive &&
                "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
              }`
            }
          >
            {({ isActive }) => (
              <>
                <AiTwotoneHome
                  color={isActive ? "#F2F2F3" : "#3c2166"}
                  size={24}
                  className="mr-2 ml-0.5 cursor-pointer"
                />
                <span className="">Home</span>
              </>
            )}
          </NavLink>
          <NavLink
            onClick={handleClose}
            to={"/projects"}
            className={({ isActive }) =>
              `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                isActive &&
                "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
              }`
            }
          >
            {({ isActive }) => (
              <>
                <BsGridFill
                  color={isActive ? "#F2F2F3" : "#3c2166"}
                  size={24}
                  className="mr-2 ml-0.5 cursor-pointer text-white"
                />
                <span className="">Projects</span>
              </>
            )}
          </NavLink>
          <NavLink
            onClick={handleClose}
            to={"/discovery"}
            className={({ isActive }) =>
              `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                isActive &&
                "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
              }`
            }
          >
            {({ isActive }) => (
              <>
                <MdExplore
                  color={isActive ? "#F2F2F3" : "#3c2166"}
                  size={26}
                  className="mr-2 ml-0.5 cursor-pointer"
                />
                <span>Discovery</span>
              </>
            )}
          </NavLink>
          <NavLink
            onClick={handleClose}
            to={"/communities"}
            className={({ isActive }) =>
              `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                isActive &&
                "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
              }`
            }
          >
            {({ isActive }) => (
              <>
                <HiUserGroup
                  color={isActive ? "#F2F2F3" : "#3c2166"}
                  size={24}
                  className="mr-2 ml-0.5 cursor-pointer"
                />
                <span>Communities</span>
              </>
            )}
          </NavLink>
          <NavLink
            onClick={handleClose}
            to={"/about"}
            className={({ isActive }) =>
              `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                isActive &&
                "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  className="mr-2 ml-0.5"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={isActive ? "#F2F2F3" : "#3c2166"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <span>About</span>
              </>
            )}
          </NavLink>
          <NavLink
            onClick={handleClose}
            to={"/contact"}
            className={({ isActive }) =>
              `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                isActive &&
                "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  className="mr-2 ml-0.5"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={isActive ? "#F2F2F3" : "#3c2166"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                <span>Contact</span>
              </>
            )}
          </NavLink>
          <ExternalLink
            key="documentation"
            href={
              "https://fundesci.gitbook.io/docs/introduction/welcome-to-fundesci"
            }
            className="font-semibold !text-black py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8"
          >
            <IoDocumentText
              size={25}
              color={"#3c2166"}
              className="mr-2 ml-0.5"
            />
            Documentation
          </ExternalLink>
        </div>

        {/* -------- profile items -------- */}
        {isLoggedIn ? (
          <div className="w-full h-full flex flex-col justify-between pr-8 mt-10">
            <div className="w-full flex flex-col">
              <div className="flex flex-col ">
                {accessToken() && role() !== UN_REGISTERED ? (
                  <div className="flex flex-col ">
                    <NavLink
                      // to={userType?.[role()]?.view}
                      onClick={handleClose}
                      to={"/profile"}
                      className={({ isActive }) =>
                        `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center pl-8 ${
                          isActive &&
                          "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <FaUserCircle
                            color={isActive ? "#F2F2F3" : "#3c2166"}
                            size={24}
                            className="mr-2 cursor-pointer"
                          />
                          <span>View profile</span>
                        </>
                      )}
                    </NavLink>
                    <NavLink
                      to="/notifications"
                      onClick={handleClose}
                      className={({ isActive }) =>
                        `font-semibold py-3.5 text-xl border-b border-b-custom-gray-200 flex items-center relative pl-8 ${
                          isActive &&
                          "border-r-4 border-[#792cf3] bg-main-gradient text-[#F2F2F3] "
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <span className="relative">
                            <IoNotificationsSharp
                              color={isActive ? "#F2F2F3" : "#3c2166"}
                              size={24}
                              className="mr-2 ml-0.5 cursor-pointer"
                            />
                            <NewNotifIcon className="absolute left-1 top-0 w-2.5 h-2.5" />
                          </span>
                          <span>Notifiactions</span>
                        </>
                      )}
                    </NavLink>
                  </div>
                ) : (
                  <button
                    onClick={handleCheckProfile}
                    className="font-semibold py-3.5 pl-8 text-xl border-b border-custom-gray-200 flex items-center"
                  >
                    <ProfileIcon className="mr-1.5 h-5 cursor-pointer" />
                    <span className="text-black">Create Profile</span>
                  </button>
                )}
                <button
                  onClick={handleDisConnect}
                  className="font-semibold flex items-center pl-8 py-3.5"
                >
                  <DisconnectIcon className="mr-3 h-6 cursor-pointer" />
                  <span className="text-[#E93C3C] text-xl">Disconnect</span>
                </button>
              </div>
              {/* ////// */}
              <div className="w-full flex flex-col gap-3 pl-8 mt-10 mb-5">
                <button
                  onClick={CreateProject}
                  className="bg-light-primary py-2.5 w-full text-center text-white text-xl rounded-3xl"
                >
                  Create Project
                </button>
                <NavLink
                  to="/create-community"
                  onClick={handleClose}
                  className="bg-gradient-to-r from-[#7e7cff] to-[#9c5cff] py-2.5 w-full text-center text-white text-xl rounded-3xl"
                >
                  Create Community
                </NavLink>
              </div>
            </div>
          </div>
        ) : (
          /* Not logged in - show auth options */
          <div className="w-full h-full flex flex-col justify-end pr-8 pb-8">
            <div className="w-full flex flex-col gap-3 pl-8">
              <div className="text-xs text-gray-600 mb-2">
                <p className="font-medium mb-1">Connect wallet to:</p>
                <ul className="text-xs space-y-1 ml-3">
                  <li>• Fund projects</li>
                  <li>• Join communities</li>
                </ul>
              </div>
              <button
                onClick={handleConnectWallet}
                className="w-full py-3.5 px-4 rounded-2xl font-semibold text-primary bg-primary/10 hover:bg-primary/20 transition-all duration-200 flex items-center justify-center gap-2 border border-primary/30"
              >
                <FaWallet size={20} />
                <span>Connect Wallet</span>
              </button>
              
              <div className="text-xs text-gray-600 my-2">
                <p className="font-medium mb-1">Sign up to:</p>
                <ul className="text-xs space-y-1 ml-3">
                  <li>• Create projects</li>
                  <li>• Create communities</li>
                </ul>
              </div>
              <button
                onClick={handleShowAuthModal}
                className="w-full py-3.5 px-4 rounded-2xl font-semibold text-white bg-gradient-to-r from-primary to-[#7e7cff] hover:shadow-lg hover:shadow-primary/30 transition-all duration-200"
              >
                Sign Up / Log In
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HamburgerMenu;
